import { CloseIcon } from "../../icons/CloseIcon";

type ModalContentProps = {
	children?: React.ReactNode;
	onClose?: () => void;
	variant?: "default" | "fullScreen";
	i18n: {
		closeButton: string;
	};
};

export const ModalContent = ({ children, onClose, variant = "default", i18n }: ModalContentProps) => {
	return (
		<>
			{onClose && variant === "default" && (
				<div className="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
					<button
						type="button"
						className="rounded-md bg-white text-icon-neutral hover:text-icon-neutral-hover"
						onClick={onClose}
					>
						<span className="sr-only">{i18n.closeButton}</span>
						<CloseIcon className="h-6 w-6" aria-hidden="true" />
					</button>
				</div>
			)}

			{children}
		</>
	);
};
